export default __webpack_public_path__ + "static/media/star.24c409b8.svg";